import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-multiple-headers-table',
  templateUrl: './multiple-headers-table.component.html',
  styleUrls: ['./multiple-headers-table.component.scss']
})
export class MultipleHeadersTableComponent implements OnInit {
  @Input() tablesData = [];
  @Input() siteNames = false;

  @Output() action: EventEmitter<any>;
  constructor() {
    this.action = new EventEmitter();
  }

  ngOnInit() {
    // Config.logger(this.tablesData);
  }
  trClick(tr) {
    this.action.emit({ type: 'td', data: tr });
  }

}
